import React, { Component } from "react";
import OktaSignInWidget from "../components/OktaSignInWidget";
import bg from "../assets/mlb-okta-bg.jpeg";
import styled from "styled-components";

const Background = styled.div`
  position: absolute;
  background-image: url(${bg});
  background-size: cover;
  height: 100vh;
  width: 100vw;
`;

class OktaLogin extends Component {
  render() {
    return (
      <Background>
        <OktaSignInWidget baseUrl={this.props.baseUrl} />
      </Background>
    );
  }
}

export default OktaLogin;
